import {
    Wrapper, Head, Btn, Intro, YT, DarkAgentFeatures, DarkAgentServices,
    AgentBackground,
    AgentImg,
    HeaderMeta,
    DarkAgentMeetSection,
    DarkAgentMeetForm, HeaderLogoHolder
} from "./theDarkAgent.Elements";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FooterDivider from "../../components/FooterDivider";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useRef, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {Helmet} from "react-helmet";
import {useCallback} from "react";
import DarkAgentThumbnail from '../../assets/images/dark-agent-thumbnail.png';
import DarkAgentF1 from '../../assets/images/dark-agent-f1.png';
import DarkAgentF2 from '../../assets/images/dark-agent-f2.png';
import DarkAgentF3 from '../../assets/images/dark-agent-f3.png';
import DarkAgentPlayIcon from '../../assets/images/dark-agent-play-icon.svg';
import DarkAgentMaximize from '../../assets/images/dark-agent-maximize.png';
import DarkAgentOptimize from '../../assets/images/dark-agent-optimize.png';
import DarkAgentSanitize from '../../assets/images/dark-agent-sanitize.png';
import {useNavigate} from "react-router-dom";
import {
    AdvisoryBackground,
    AdvisoryCover,
    AdvisoryImg,
    AdvisoryTextBody,
    AdvisoryTextTitle,
    AdvisoryTitle,
    CornImg,
    CoverBody,
    CoverTitle
} from "../advisory/AdvisoryElement";
import {CornMobile, ScrollTop} from "../home/HomeElements";
import scrollTopIcon from "../../assets/images/ScrolltoTopIcon.png";
import {FieldRow, FormRow} from "../contactUs/ContactUsElement";
import {Input} from "@mui/material";
import {SpanPolicy} from "../../components/EmailForm/EmailFormElements";
import agent from "../../utils";
import {toast} from "react-toastify";
import {isValidEmail} from '../../helpers/email-helper';
import DarkAgentLogoImg from "../../assets/images/darkiagent.png";
import CaptchaDialog from "../../common/captchaDialoge";
import ThanksDialog from "../../common/thanksDialog";
import {Link} from 'react-router-dom';

const TheDarkAgent = ({isScrolled, setReshowDialog}) => {
    const isMobile = useMediaQuery({query: `(max-width: 800px)`});
    const [playVideo, setPlayVideo] = useState(false);
    const targetSection = useSelector((state) => state.scroll.targetSection);
    const navigate = useNavigate();

    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [messageValidation, setMessageValidation] = useState(false);

    const fieldsStyle = {flex: '1 1 auto', marginTop: '3vh'};
    //captcha
    const [loading, setLoading] = useState(false);
    const [captchaKey, setCaptchaKey] = useState(null);
    const [captchaOpen, setCaptchaOpen] = useState(false);
    const [thanksOpen, setThanksOpen] = useState(false);
    const invalidEmailMessage = "Email is not valid";

    const sxProps = {
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#002F87',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#002F87',
            },
            '&:hover fieldset': {
                borderColor: '#002F87',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#002F87',
            }
        },
        '& .MuiInputBase-input': {
            width: '100%',
            fontSize: '15px'
        }
    };

    useEffect(() => {
        if (targetSection === null) {
            window.scrollTo(0, 0);
        }
    }, [])

    const submitDemo = () => {
        if (isValidEmail(email)) {
            setIsLoading(true);
            agent.DarkAgentDemos.postEmail({
                "email": email,
                "g-recaptcha-response": captchaKey
            }).then(() => {
                setEmail("");
                setCaptchaOpen(false);
                toast.success("Request was sent")
            }).catch(() => {
                toast.error("An error occurred")
            }).finally(() => {
                setIsLoading(false);
                setMessageValidation(null);
            })
        } else {
            setMessageValidation(invalidEmailMessage);
        }
    }
    const handleSubmit = () => {
        if (localStorage.getItem('cookie') !== '1')
            setReshowDialog(true);
        else {
            if (isValidEmail(email)) {
                setCaptchaOpen(true);
            } else {
                setMessageValidation(invalidEmailMessage);
            }
        }
    }
    return <>
        <Helmet>
            <title>The Dark Agent</title>
            <meta name="robots" content="nofollow"></meta>
            <meta name="description"
                  content="Your Ultimate Digital Risk and Threat Intel Ally"/>
            {/* <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
                  integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
                  crossOrigin="anonymous"/> */}
        </Helmet>
        <Wrapper>
            <AgentBackground>
                <AgentImg/>
                <HeaderMeta className={'header-meta'}>
                    <div className="meta-intro">
                        <Link to="/darkivore">Darkivore</Link><br/> Unleashes Its New AI
                        Assistant
                    </div>
                    <div className="meta-logo-holder">
                        <img alt={''} className={'img-fluid'} src={DarkAgentLogoImg}/>
                        <span>The Dark Agent</span>
                    </div>
                    <div className="meta-body">
                        Your Ultimate Digital Risk <br/>and Threat Intel Ally
                    </div>
                </HeaderMeta>
                <ScrollTop isScrolled={isScrolled} src={scrollTopIcon} onClick={() => {
                    window.scrollTo(0, 0)
                }}/>
            </AgentBackground>
            <DarkAgentMeetSection>
                <CornImg>
                    <svg width="5vw" height="64" viewBox="0 0 95 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M93.2442 59.4236C92.3635 60.5719 91.0927 61.5253 89.5607 62.187C88.0286 62.8487 86.29 63.1951 84.5213 63.191H10.7127C8.94399 63.196 7.20501 62.8505 5.67236 62.1895C4.13972 61.5286 2.86799 60.5758 1.98633 59.4279C1.10466 58.2799 0.644456 56.9778 0.652446 55.6537C0.660436 54.3295 1.13634 53.0306 2.03182 51.8887L38.8942 4.16745C39.7767 3.01972 41.0476 2.06639 42.579 1.40351C44.1104 0.740626 45.8481 0.391602 47.617 0.391602C49.386 0.391602 51.1237 0.740626 52.655 1.40351C54.1864 2.06639 55.4574 3.01972 56.3399 4.16745L93.2022 51.8887C94.1045 53.0281 94.584 54.3272 94.5914 55.6518C94.5988 56.9765 94.1337 58.2785 93.2442 59.4236Z"
                            fill="url(#paint0_linear_51_664)" style={{mixBlendMode: 'normal'}}/>
                        <defs>
                            <linearGradient id="paint0_linear_51_664" x1="0.652344" y1="31.7913" x2="94.5915"
                                            y2="31.7913" gradientUnits="userSpaceOnUse">
                                <stop offset="0.253125" stopColor="#bcbcbc"/>
                                <stop offset="0.711458" stopColor="#bababa"/>
                            </linearGradient>
                        </defs>
                    </svg>
                </CornImg>
                <CornMobile>
                    <svg width="46" height="40" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M45.3402 37.0986C44.909 37.8203 44.2867 38.4194 43.5365 38.8353C42.7863 39.2511 41.9349 39.4688 41.0689 39.4663H4.92635C4.06024 39.4694 3.2087 39.2522 2.4582 38.8369C1.70769 38.4215 1.08496 37.8227 0.653222 37.1013C0.22149 36.3799 -0.00386255 35.5616 5.00943e-05 34.7294C0.00396274 33.8973 0.237 33.0809 0.675499 32.3633L18.7262 2.37293C19.1584 1.65164 19.7807 1.05252 20.5306 0.635934C21.2805 0.219344 22.1314 0 22.9976 0C23.8638 0 24.7147 0.219344 25.4646 0.635934C26.2145 1.05252 26.8369 1.65164 27.269 2.37293L45.3197 32.3633C45.7615 33.0794 45.9963 33.8958 46 34.7283C46.0036 35.5607 45.7758 36.379 45.3402 37.0986Z"
                            fill="url(#paint0_linear_1_662)" style={{mixBlendMode: 'normal'}}/>
                        <defs>
                            <linearGradient id="paint0_linear_1_662" x1="0" y1="19.7332" x2="46" y2="19.7332"
                                            gradientUnits="userSpaceOnUse">
                                <stop stop-color="#bcbcbc"/>
                                <stop offset="1" stop-color="#bababa"/>
                            </linearGradient>
                        </defs>
                    </svg>
                </CornMobile>
                <div className="title">
                    Dark Agent addresses the critical challenges faced by security professionals dealing with the
                    overwhelming volume and complexity of threat data.
                    <br/>
                    By automating key processes, delivering actionable insights, and conducting takedowns on user’s
                    behalf, the Dark Agent significantly reduces the time and effort required to neutralize threats.
                </div>
                <div className="row">
                    <YT className={playVideo ? 'video-playing' : ''}>
                        {
                            !playVideo &&
                            <div className="video-thumbnail-wrapper">
                                <img width={'100%'} src={DarkAgentThumbnail} alt={''} className={'bg-img img-fluid'}/>
                                <img onClick={() => setPlayVideo(true)} src={DarkAgentPlayIcon} alt={'play'}
                                     className={'play-icon'}/>
                            </div>
                        }

                        {
                            playVideo &&
                            <div className={'iframe-holder'}>
                                <iframe style={{borderRadius: 20}} width={'100%'} height={'100%'}
                                        src="https://www.youtube.com/embed/Q7xutaYMv94?autoplay=1"
                                        title="Dummy Video For Website" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                            </div>
                        }
                    </YT>

                    <CaptchaDialog
                        loading={loading}
                        open={captchaOpen}
                        setOpen={setCaptchaOpen}
                        submitHandler={submitDemo}
                        btnText={'SUBMIT'}
                        setCaptchaKey={setCaptchaKey}
                    />
                    <ThanksDialog open={thanksOpen} setOpen={setThanksOpen} title={'Thank You For Your Message!'}/>
                    <DarkAgentMeetForm>
                        <div className="form-title">
                            Meet the <br/>Dark Agent.
                        </div>
                        <div className="form-comment">
                            Leave your email to get a free demo!
                        </div>
                        <FormRow compact>
                            <FieldRow>
                                <Input
                                    placeholder="Email"
                                    value={email}
                                    onChange={event => {
                                        setEmail(event.target.value?.trim());
                                        setMessageValidation(null);
                                    }}
                                    style={fieldsStyle}
                                    sx={sxProps}/>
                            </FieldRow>
                        </FormRow>
                        <div className="form-error">{messageValidation ?? ''}</div>
                        <div className="form-message">
                            By submitting your email address, you agree to receiving emails from potech and acknowledge
                            our <SpanPolicy style={{fontStyle: 'normal'}} target="_blank" href="/privacy_notice">Privacy
                            Policy</SpanPolicy>.
                        </div>
                        <button className="form-button" onClick={handleSubmit} disabled={isLoading}>
                            REQUEST DEMO
                        </button>
                    </DarkAgentMeetForm>
                </div>
            </DarkAgentMeetSection>
            <DarkAgentFeatures>
                <div className="row">
                    <div className="col">
                        <div className="title">Maximize Takedowns</div>
                        <div className="description">Streamlines the takedown process by automating the selection of
                            relevant targets, generating
                            detailed investigation reports, and launching the takedown.
                        </div>
                        <img alt={''} src={DarkAgentMaximize} className="img-sample1"/>
                    </div>
                    <div className="col"><img className="img" alt={''} src={DarkAgentF1}/></div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="title">Optimize Reports</div>
                        <div className="description">Provides contextual answers related to the customer’s latest
                            threats, dramatically
                            accelerating data visibility and enabling faster decision-making.
                        </div>
                        <img alt={''} src={DarkAgentOptimize} className="img-sample2"/>
                    </div>
                    <div className="col"><img className="img" alt={''} src={DarkAgentF2}/></div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="title">Sanitize The Noise</div>
                        <div className="description">Effectively filters out false positives and irrelevant data,
                            reducing the burden of sifting
                            through massive datasets and allowing security teams to focus on genuine threats.
                        </div>
                        <img alt={''} src={DarkAgentSanitize} className="img-sample3"/>
                    </div>
                    <div className="col"><img className="img" alt={''} src={DarkAgentF3}/></div>
                </div>
            </DarkAgentFeatures>
            <DarkAgentServices>
                <div className="row">
                    <div className="col">
                        <div className="title">Edge-Based Security</div>
                        <div className="description">
                            Operates on an edge-based architecture, prioritizing super-secure, zero-data access for
                            customer privacy. Dark Agent does not have access to customer data, ensuring maximum
                            confidentiality.
                        </div>
                    </div>
                    <div className="col">
                        <div className="title">Multi-Lingual Support</div>
                        <div className="description">
                            Facilitates seamless communication with Darkivore’s core engine, regardless of language
                            barriers.(English, French, Spanish and Arabic in the first pilot).
                        </div>
                    </div>
                </div>

                <DarkAgentMeetForm width="90vw" flexDirection="row" padding="50px">
                    <div>
                        <div className="form-title">
                            Meet the Dark Agent.
                        </div>
                        <div className="form-comment">
                            Leave your email to get a free demo!
                        </div>
                    </div>
                    <div>
                        <FormRow compact>
                            <FieldRow>
                                <Input
                                    placeholder="Email"
                                    value={email}
                                    onChange={event => {
                                        setEmail(event.target.value?.trim());
                                        setMessageValidation(null);
                                    }}
                                    style={fieldsStyle}
                                    sx={sxProps}/>
                            </FieldRow>
                        </FormRow>
                        <div className="form-error">{messageValidation ?? ''}</div>
                        <div className="form-message">
                            By submitting your email address, you agree to receiving emails from potech and acknowledge
                            our <SpanPolicy style={{fontStyle: 'normal'}} target="_blank" href="/privacy_notice">Privacy
                            Policy</SpanPolicy>.
                        </div>
                        <button className="form-button" onClick={handleSubmit} disabled={isLoading}>
                            REQUEST DEMO
                        </button>
                    </div>
                </DarkAgentMeetForm>
            </DarkAgentServices>
        </Wrapper>
    </>
}

export default TheDarkAgent;
